import { Box } from "@mui/material";
import { Sidebar } from "./Sidebar";
import { ContentCalendar } from "./ContentCalendar";

export function ContentCalendarWrapper() {
    return (
        <Box display="flex" height="100vh">
          <Sidebar selected="content-calendar" />
        
          <Box display="flex" flexDirection="column" flexGrow={1} >
            <ContentCalendar />
          </Box>
        </Box>
    )
}